module.exports = __webpack_public_path__ + "static/media/cahli_charity.e76894e5.jpg";